import graphics from "../assets/images/log.png";
import graphicsRmBg from "../assets/images/logos_transparent.png";
import animals from "../assets/images/animals.jpg";
import animalsRmBg from "../assets/images/animals-removebg.png";
import cars from "../assets/images/cars.jpg";
import carsRmBg from "../assets/images/cars_removebg.png";
import product from "../assets/images/original.jpg";
import productRmBg from "../assets/images/products_no_background.png";

import people from "../assets/images/persons3.jpg";
import peopleRmBg from "../assets/images/persons3-nobg.png";

import graphics01 from "../assets/demo/graphics_01.png";
import graphics02 from "../assets/demo/graphics_02.png";
import graphics03 from "../assets/demo/graphics_03.png";
import graphics04 from "../assets/demo/graphics_04.png";
import graphics05 from "../assets/demo/graphics_05.png";

import person01 from "../assets/demo/01-person.jpg";
import person02 from "../assets/demo/02-person.png";
import person03 from "../assets/demo/03-person.jpg";
import person04 from "../assets/demo/04-person.jpg";
import person05 from "../assets/demo/05-person.jpg";

import cat01 from "../assets/demo/01-cat.jpg";
import cat02 from "../assets/demo/02-cat.png";
import cat03 from "../assets/demo/03-cat.jpg";
import cat04 from "../assets/demo/04-cat.jpg";
import cat05 from "../assets/demo/05-cat.jpg";

import cars01 from "../assets/demo/01_cars1.jpg";
import cars02 from "../assets/demo/01_cars2.png";
import cars03 from "../assets/demo/01_cars3.jpg";
import cars04 from "../assets/demo/01_cars4.jpg";
import cars05 from "../assets/demo/01_cars5.jpg";

import shirt1 from "../assets/demo/01-shirt.jpg";
import shirt2 from "../assets/demo/02-shirt.png";
import shirt3 from "../assets/demo/03-shirt.jpg";
import shirt4 from "../assets/demo/04-shirt.jpg";
import shirt5 from "../assets/demo/05-shirt.jpg";

import thumbnail1 from "../assets/images/1_thumbnail.jpg";
import thumbnailImg1 from "../assets/images/1.jpg";

import thumbnail2 from "../assets/images/2_thumbnail.jpg";
import thumbnailImg2 from "../assets/images/2.jpg";

import thumbnail3 from "../assets/images/3_thumbnail.jpg";
import thumbnailImg3 from "../assets/images/3.jpg";

import thumbnail4 from "../assets/images/4_thumbnail.jpg";
import thumbnailImg4 from "../assets/images/4.jpg";

import design from "../assets/images/design-photo.svg";
import ecommerce from "../assets/images/e-commerce.svg";
import cms from "../assets/images/cms.svg";
import automation from "../assets/images/automation.svg";
import commandline from "../assets/images/api-commandline.svg";

import linux from "../assets/images/rbg-macos-app-icon-2x.png";
import android from "../assets/images/android-new-2019-logo-3cd3bc571c-seeklogo-com.png";
import photoshop from "../assets/images/768px-adobe_photoshop_cc_icon-svg.png";
import cmd from "../assets/images/commandline.png";
import figma from "../assets/images/figma.jpg";
import gimp from "../assets/images/gimp.jpg";
import adobe from "../assets/images/creative_cloud-logo.png";
import sketch from "../assets/images/sketch.jpg";

const dataShow = [
  {
    id: 1,
    name: "People",
    src: people,
    srcRmBg: peopleRmBg,
  },
  {
    id: 2,
    name: "Products",
    src: product,
    srcRmBg: productRmBg,
  },
  {
    id: 3,
    name: "Animal",
    src: animals,
    srcRmBg: animalsRmBg,
  },
  {
    id: 4,
    name: "Cars",
    src: cars,
    srcRmBg: carsRmBg,
  },
  {
    id: 5,
    name: "Graphics",
    src: graphics,
    srcRmBg: graphicsRmBg,
  },
];

const dataLiveShow = [
  {
    id: "01",
    title: "People",
    original: person01,
    removeBg: person02,
    newBg: person03,
    layout1: person04,
    layout2: person05,
  },
  {
    id: "02",
    title: "Products",
    original: shirt1,
    removeBg: shirt2,
    newBg: shirt3,
    layout1: shirt4,
    layout2: shirt5,
  },
  {
    id: "03",
    title: "Animals",
    original: cat01,
    removeBg: cat02,
    newBg: cat03,
    layout1: cat04,
    layout2: cat05,
  },
  {
    id: "04",
    title: "Cars",
    original: cars01,
    removeBg: cars02,
    newBg: cars03,
    layout1: cars04,
    layout2: cars05,
  },
  {
    id: "05",
    title: "Graphics",
    original: graphics01,
    removeBg: graphics02,
    newBg: graphics03,
    layout1: graphics04,
    layout2: graphics05,
  },
];

const dataHomeDemo = [
  {
    id: "001",
    thumbnail: thumbnail1,
    src: thumbnailImg1,
  },
  {
    id: "002",
    thumbnail: thumbnail2,
    src: thumbnailImg2,
  },
  {
    id: "003",
    thumbnail: thumbnail3,
    src: thumbnailImg3,
  },
  {
    id: "004",
    thumbnail: thumbnail4,
    src: thumbnailImg4,
  },
];

const navBar = [
  {
    id: "0001",
    title: "Tools & API",
    svg: "",
  },
  {
    id: "0002",
    title: "Design & Photo Editing",
    svg: design,
  },
  {
    id: "0003",
    title: "E-Commerce",
    svg: ecommerce,
  },
  {
    id: "0004",
    title: "Content Management",
    svg: cms,
  },
  {
    id: "0005",
    title: "Automation",
    svg: automation,
  },
  {
    id: "0006",
    title: "API & Command Line",
    svg: commandline,
  },
];

const navSlide = [
  {
    id: "01",
    title: "Command Line Interface",
    content: "Remove backgrounds automatically using a text-based command. ",
    src: cmd,
  },

  {
    id: "02",
    title: "Remove.bg for Windows, Mac & Linux",
    content: "Automate your background removal workflow with our desktop app.",
    src: linux,
  },
  {
    id: "03",
    title: "Android App",
    content: " Remove image backgrounds on the go wherever you may be. ",
    src: android,
  },
  {
    id: "04",
    title: "Photoshop Plugin",
    content:
      " Streamline photo editing by integrating the remove.bg plugin directly in Photoshop. ",
    src: photoshop,
  },
];

const navDesign = [
  {
    id: "101",
    title: "Command Line Interface",
    author: "by Kaleido",
    src: cmd,
  },
  {
    id: "102",
    title: "Remove.bg for Windows, Mac & Linux",
    author: "by Kaleido",
    src: linux,
  },
  {
    id: "103",
    title: "Android App",
    author: "by Kaleido",
    src: android,
  },
  {
    id: "104",
    title: "Photoshop Plugin",
    author: "by Kaleido",
    src: photoshop,
  },
  {
    id: "105",
    title: "Gimp Plugin",
    author: "by manu1212199",
    src: gimp,
  },
  {
    id: "106",
    title: "Figma Plugin",
    author: "by Aaron Iker",
    src: figma,
  },
  {
    id: "107",
    title: "Sketch Plugin",
    author: "by mathieu dutour",
    src: sketch,
  },
  {
    id: "108",
    title: "Adobe Creative Cloud Libraries",
    author: "via Zapier",
    src: adobe,
  },
];

const subscriptionData = [
  { id: "01", unit: "40", total: "9", price: "0.23" },
  { id: "02", unit: "200", total: "39", price: "0.20" },
  { id: "03", unit: "500", total: "89", price: "0.18" },
  { id: "04", unit: "1,200", total: "189", price: "0.16" },
  { id: "05", unit: "2,800", total: "389", price: "0.14" },
  { id: "06", unit: "5,000", total: "589", price: "0.12" },
  { id: "07", unit: "7,500", total: "789", price: "0.11" },
  { id: "04", unit: "10,000", total: "989", price: "0.10" },
];

const creditData = [
  { id: "01", unit: "1", total: "1.99", price: "1.99" },
  { id: "02", unit: "10", total: "9", price: "0.90" },
  { id: "03", unit: "75", total: "49", price: "0.65" },
  { id: "04", unit: "200", total: "99", price: "0.50" },
  { id: "05", unit: "4.000", total: "999", price: "0.25" },
  { id: "06", unit: "8,000", total: "1,699", price: "0.21" },
];

const dataQuestionAnswer = [
  {
    id: "01",
    question: "Should I get Pay-as-you-go credits or a subscription?",
    answers: [
      "For one-off or hard-to-predict image needs, pay as you go credits are a great option.",
      "For larger or ongoing image needs, you'll save on every photo that you process with a subscription. With monthly plans starting at just 40 images per month and rollover of any unused credits (up to 5×) you'll benefit from huge savings without making a huge commitment.",
    ],
  },
  {
    id: "02",
    question: "What are credits?",
    answers: [
      "Credits enable you to use remove.bg for full resolution cutouts in high quality. You can use credits on remove.bg, via the remove.bg API, in our Windows / Mac / Linux app or Photoshop Extension.",
      "Removing the background from 1 image requires 1 credit. Preview images are free on remove.bg and ¼ credit via the remove.bg apps and API.",
      "Subscriptions include a monthly budget of credits, that you can use within that month (or roll over to the next month as long as you stay subscribed). Pay-as-you-go credits are valid for up to 2 years after the purchase.",
    ],
  },
  {
    id: "03",
    question: "What images are supported?",
    answers: [
      "You can upload any JPG or PNG image with up to 12 megabytes. Images must have a subject that is clearly meant to be the foreground, such as a person, animal, product or car (more info). If the image resolution is larger than 25 megapixels (e.g. 6250  4000 pixels or any other aspect ratio) it is resized to this maximum resolution.",
    ],
  },
  {
    id: "04",
    question: "What are preview images?",
    answers: [
      "Preview images are small resolution cutouts with up to 0.25 megapixels (e.g 625x400 pixels).",
      "They are FREE on remove.bg and significantly cheaper than regular images (¼ credit instead of 1 credit) when requested through the API.",
    ],
  },
  {
    id: "05",
    question: "Can I cancel/upgrade/downgrade my subscription?",
    answers: [
      "Yes, you can cancel, upgrade or downgrade your subscription any time.",
      "Note: If you cancel your subscription, unused subscription credits can only be used until the end of the billing period. Read more",
    ],
  },
  {
    id: "06",
    question: "What if I am unsatisfied with the results?",
    answers: [
      "At the moment remove.bg works very well for photos of persons, products and cars, but some images are more challenging than others. We recommend uploading a few images to the free version to get an impression of the quality level for your specific images. You can also try 1 image for free by signing up.",
      "All subscriptions are covered by a 14 Day Money Back Guarantee: You get a full refund within 14 days if you are unsatisfied with the results (restricted to 50 downloads). Have a look at our Refund Policy.",
      "Subscriptions with 7,500 credits per month or more: You only pay for images that meet your required quality level. Read more about the Quality Guarantee.",
    ],
  },
  {
    id: "07",
    question:
      "What happens if I don't use all my subscription credits each month?",
    answers: [
      "If at the end of the month you have not used all of your subscription credits, the remaining credits roll over to the next month - so you can still use them.",
      "You can roll over up to 5 × your monthly credit budget. For instance, if you are subscribed to the 500 credits / month plan, you get 500 credits each month and on top of that you can roll over up to 2,500 credits from previous months. Learn more",
    ],
  },
  {
    id: "08",
    question: "What if I run out of credits?",
    answers: [
      "When you have used 80% of your monthly credits of a subscription, you will be notified via email. Once you have used up all credits, no further background removals are possible until next month (except for preview images on remove.bg which are always free). Should you need more credits, you can either upgrade your plan or purchase a pay as you go package.",
      "There are no overage charges. If you want to make sure you never run out of credits, have a look at this article.",
    ],
  },
  {
    id: "09",
    question: "What payment methods do you support?",
    answers: ["We support all major Credit Cards, PayPal and Apple Pay."],
  },
  {
    id: "10",
    question: "What's the API for?",
    answers: [
      "You can use our API to integrate the background removal in your website, app or workflow. It's a simple HTTP-based interface with various options. You can find the docs here.",
      "Our apps for Windows / Mac / Linux and Photoshop are built on top of the API.",
    ],
  },
  {
    id: "11",
    question: "How many images can I process simultaneously through the API?",
    answers: [
      "You can process up to 500 images per minute. If you require more than that, get in touch.",
    ],
  },
  {
    id: "12",
    question: "Is remove.bg GDPR compliant?",
    answers: [
      "Yes, we are 100% GDPR compliant. You can find more on this topic in our Privacy Policy.",
    ],
  },
];
export {
  subscriptionData,
  creditData,
  dataShow,
  dataLiveShow,
  dataHomeDemo,
  navBar,
  navSlide,
  navDesign,
  dataQuestionAnswer
};
// export demo;
